<template>
  <div class="view">
    <Title title="イベント(クローズド)"/>
    <EventClosedEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventClosedEditMain from '@/components/EventClosed/EditMain'

export default {
  components: {
    Title,
    EventClosedEditMain
  }
}
</script>

